export default __webpack_public_path__ + "2a19c762abf84e5a58effc3e257d19b0.png";